import styled, { css } from "styled-components";
import { getColor, getShadow, getSize, responsive } from "~/helpers/style";
import { UIProps } from "~/types/style";
import Button from "../Button";

interface ICategoryItem extends UIProps {
  fillRow?: boolean;
}

export const CategoryItem = styled.div<ICategoryItem>`
  display: flex;
  background-color: ${getColor("white")};
  border-radius: ${getSize(0.6)};
  align-items: center;
  position: relative;
  overflow: hidden;
  grid-row: ${({ fillRow }) => (fillRow ? "1 / -1" : "")};
  height: 100%;
  cursor: pointer;
  transition: 0.6s cubic-bezier(0.65, 0, 0.35, 1);
  flex-grow: 1;
  height: ${getSize(7.6)};
  max-height: ${getSize(16.4)};

  img {
    max-width: ${getSize(12.2)};
    object-fit: scale-down;
    width: 40%;
    margin-top: 7px;
  }

  ${responsive("laptopL")} {
    height: ${({ fillRow }) => (fillRow ? "100%" : getSize(7.6))};
  }

  &:hover {
    box-shadow: ${getShadow("md")};
  }

  ${responsive("tablet", true)} {
    border-radius: 6x;
    height: 68px;
    min-width: 213px;
  }
`;

export const Text = styled.p`
  margin: 0 ${getSize(0.8)};
  font-size: ${getSize(1.6)};
  color: ${getColor("black")};
  font-weight: 500;
  width: fit-content;

  ${responsive("tablet", true)} {
    color: ${getColor("colorBlack")};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    font-family: Ubuntu;
    width: 100%;
  }
 
`;

export const CategoryImage = styled.img`
  width: ${getSize(7.6)};
  height: ${getSize(7.6)};
`;

interface ICategoriesGrid extends UIProps {
  rows: number;
  columns: number;
}

export const CategoriesGrid = styled.div<ICategoriesGrid>`
  display: flex;
  flex-wrap: wrap;
  grid-gap: ${getSize(1.2)};
  grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
  grid-template-rows: ${({ rows }) => `repeat(${rows}, 1fr)`};
  align-items: center;
  margin: ${getSize(1.4)} 0;

  ${responsive("laptopL")} {
    display: grid;
  }

  ${responsive("tablet", true)} {
    display: flex; 
    flex-wrap: nowrap;
    gap: 12px;
    overflow-y: auto;
    align-items: center;
    scrollbar-width: none;
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      width: 0px;
    }
  }
`;

export const DropdownButton = styled(Button)`
  display: flex;
  background-color: ${getColor("white")};
  border-radius: ${getSize(0.6)};
  align-items: center;
  height: 100%;
  width: 100%;
  flex-grow: 1;
  height: ${getSize(7.6)};
  max-height: ${getSize(16.4)};
  font-weight: 400;
  font-size: ${getSize(1.4)};
  padding: ${getSize(1.0)} ${getSize(1.1)} ${getSize(1.0)} ${getSize(1.7)};

  & > div {
    gap: ${getSize(2.9)};
    justify-content: space-between;
  }
`;

export const DropdownContainer = styled.div`
  position: relative;
  isolation: isolate;
  z-index: 10;
  flex-grow: 1;

  ${responsive("tablet", true)} {
    width: 165px;
  }
`;
interface IDropdownContent extends UIProps {
  side: "left" | "right";
  dropdownTop?: number;
  dropdownLeft?: number;
  dropdownWidth?: number;
}

export const DropdownContent = styled.div<IDropdownContent>`
  position: absolute;
  ${({ side }) => css`
    ${side}: 0;
  `}
  top: calc(100% + 4px);
  max-height: ${getSize(20.0)};
  overflow-y: auto;

  align-items: center;
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: ${getSize(0.4)};

  border-radius: ${getSize(0.8)};
  border: 1px solid #f2f4f7;
  box-shadow:
    0px 4px 6px -2px #10182808,
    0px 12px 16px -4px #10182814;
  background-color: ${getColor("backgroundSecondary")};

  ${responsive("tablet")} {
    width: max-content;
    grid-template-columns: minmax(50%, max-content) minmax(50%, max-content);
  }

  ${responsive("tablet", true)} {
    position: fixed;
    top: ${({ dropdownTop }) => (dropdownTop !== undefined ? `${dropdownTop}px` : "0")};
    left: ${({ dropdownLeft }) => (dropdownLeft !== undefined ? `${dropdownLeft}px` : "0")};
    z-index: 9999;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    box-sizing: border-box;
    overflow-y: auto;
    padding: 24px 12px;
    background: ${getColor("backgroundSecondary")};
    width: ${({ dropdownWidth }) => (dropdownWidth !== undefined ? `${dropdownWidth}px` : "max-content")};
    height: auto;
    max-height: 400px;
  }
`;

export const DropdownItem = styled(Button)`
  min-width: ${getSize(18.0)};

  padding: ${getSize(1.0)} ${getSize(1.4)};
  font-size: ${getSize(1.4)};
  font-weight: 500;
  line-height: ${getSize(2.0)};

  & > div {
    justify-content: flex-start;
  }
`;
